import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';
import { count, sum } from '@utils/summaries';
import { useReportLoad } from '@hooks/useReportLoad';
import { BaseReport } from '../BaseReport';
import { REPORT } from '@consts/reports';

interface CutsByCategoryProps {
    dateRange: { startDate: string; endDate: string };
}

export const CutsByCategory = ({ dateRange }: CutsByCategoryProps) => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.CUT_BY_CATEGORY,
        params: { ...dateRange },
        v2: true,
    });

    return (
        <BaseReport
            title={'Cuts by Category'}
            description={
                'This report shows the number of successful cuts by device category. The chart below provides a visual breakdown of the data.'
            }
            note={
                'Only cuts made by machines with the new version of the kiosk software will be included in this report.'
            }
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Device Category', 'Successful Cuts'],
                data: data.map((item) => [item.category, item.count]),
                summaries: [count, sum],
                sort: [basicSort, basicSort],
            }}
            chartOptions={{
                chart: {
                    type: 'pie',
                    animation: false,
                    height: 300,
                },
                legend: {
                    layout: 'vertical',
                    align: 'center',
                    verticalAlign: 'middle',
                    padding: 20,
                    x: 120,
                    maxHeight: 200,
                    labelFormat: '{name}: ({y}) <b>[{percentage:.1f}]%</b>',
                },
                plotOptions: {
                    pie: {
                        center: ['40%', '50%'],
                        allowPointSelect: false,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false,
                        },
                        showInLegend: true,
                    },
                    series: {
                        animation: {
                            duration: 0,
                        },
                    },
                },
                title: 'Manufacturer Breakdown',
                credits: { enabled: false },
                tooltip: {
                    pointFormat: '{point.name}: {point.y} <b>[{point.percentage:.1f}]%</b>',
                },
                series: [{ data: data.map((item) => ({ name: item.category, y: item.count })) }],
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 600,
                            },
                            chartOptions: {
                                legend: {
                                    x: 0,
                                    verticalAlign: 'bottom',
                                    align: 'center',
                                    maxHeight: 85,
                                    padding: 0,
                                    margin: 0,
                                },
                                plotOptions: {
                                    pie: {
                                        center: ['50%', '50%'],
                                        size: 180,
                                    },
                                },
                            },
                        },
                        {
                            condition: {
                                maxWidth: 960,
                                minWidth: 601,
                            },
                            chartOptions: {
                                legend: {
                                    x: 130,
                                },
                                plotOptions: {
                                    pie: {
                                        center: ['38%', '45%'],
                                        size: 200,
                                    },
                                },
                            },
                        },
                    ],
                },
            }}
        />
    );
};
